module.exports = __webpack_public_path__ + "static/media/web_th.c985dda6.png";